import React, { useEffect, useState } from 'react';
import './NotFound.scss';

import { showGlobalHeaderFooter } from '../../../actionCreators/header';
import { useDispatch, useSelector } from 'react-redux';

import Helmet from 'react-helmet';
import NotFoundImage from '../../../../static/assets/img/notFound/not-found-image.png';
import NotFoundText from '../../../../static/assets/img/notFound/not-found-text.png';
import RecentlyViewedProducts from '../../CommonComponents/RecentlyViewedProducts/RecentlyViewedProducts';

const NotFound = () => {
  const {
    PAGE_NOT_FOUND,
    PAGE_NOT_FOUND_DESCRIPTION,
    PAGE_NOT_FOUND_ACTION_1,
    PAGE_NOT_FOUND_ACTION_2,
    PAGE_NOT_FOUND_ACTION_3,
    PAGE_NOT_FOUND_ACTION_4,
  } = useSelector(state => state.locale);

  const dispatch = useDispatch();

  const [headerHeight, setHeaderHeight] = useState('');

  useEffect(() => {
    dispatch(showGlobalHeaderFooter({ header: true, footer: false }));
  }, [dispatch]);

  useEffect(() => {
    window.onload = () => {
      const headerPlaceholder = document.querySelector('.header-placeholder');
      if (headerPlaceholder) {
        const headerHeight = headerPlaceholder.clientHeight;
        setHeaderHeight(headerHeight);
      }
    };
  }, []);

  return (
    <div className="od-not-found">
      <Helmet title="Error Page" />
      <div className="od-not-found-img">
        <img alt="Not found" src={NotFoundImage} />
      </div>
      <div className="od-not-found-info">
        <img alt="Not found" src={NotFoundText} />

        <div className="od-not-found-info__title od-font-light">{PAGE_NOT_FOUND}</div>

        <div className="od-not-found-info__description od-font-reg">
          {PAGE_NOT_FOUND_DESCRIPTION}
        </div>

        <div className="od-not-found-info__action">
          {PAGE_NOT_FOUND_ACTION_1}{' '}
          <span
            className="od-not-found-info__action-link od-font-bold"
            onClick={() => window.history.go(-1)}
          >
            {PAGE_NOT_FOUND_ACTION_2}
          </span>{' '}
          {PAGE_NOT_FOUND_ACTION_3}{' '}
          <a className="od-not-found-info__action-link od-font-bold" href="/sg/en">
            {PAGE_NOT_FOUND_ACTION_4}
          </a>
        </div>
      </div>
      <div className="od-not-found__recently-viewed">
        <RecentlyViewedProducts device="desktop" />
      </div>
    </div>
  );
};

export default NotFound;
